<!-- 价格信息 -->
<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="价格编号">
              <j-input placeholder="请输入价格编号模糊搜索" v-model="queryParam.wtCode"></j-input>
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('价格名称')">
              <j-input :placeholder="$t('请输入价格名称模糊搜索')" v-model="queryParam.wtName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('阶梯数量')">
              <j-dict-select-tag v-model="queryParam.wtStepNum" :placeholder="$t('请选择阶梯数量')"
                dictCode="wt_step_num"></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('禁用状态')">
              <j-dict-select-tag v-model="queryParam.statusDisable" :placeholder="$t('请选择禁用状态')" dictCode="status_disable" />
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('计费类型')">
                <j-dict-select-tag v-model="queryParam.wtFeeType" :placeholder="$t('请选择计费方式')" dictCode="wt_fee_type" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('阶梯计费方式')">
                <j-dict-select-tag v-model="queryParam.wtStepCalWay" :placeholder="$t('请选择计费方式')" dictCode="wt_step_cal_way" />
              </a-form-item>
            </a-col>
            <!--
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="阶梯状态">
                <a-input placeholder="请输入阶梯状态" v-model="queryParam.wtStepState"></a-input>
              </a-form-item>
            </a-col>
            -->
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>
      <a-table ref="table" size="middle" :scroll="{x:true}" bordered rowKey="id" :columns="columns"
        :dataSource="dataSource" :pagination="ipagination" :loading="loading" class="j-table-force-nowrap fixed-height"
        :customRow="customRow" :rowSelection="{type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange" :class="{'top-table': selectedRowKeys.length>0}">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <div style="margin-top: 20px;" v-if="selectedRowKeys.length>0">
      <a-table ref="table" size="middle" :scroll="{x:true}" bordered rowKey="id" :columns="columns1"
        :dataSource="dataSource1" :loading="loading" :pagination="false" class="j-table-force-nowrap fixed-height"
        @change="handleTableChange">
        <span slot="price" slot-scope="text, record">
          {{record.price|divideMoneyBy100Filter}}</span>
      </a-table>
    </div>
    <meter-priceinfo-modal ref="modalForm" @ok="modalFormOk"></meter-priceinfo-modal>
  </div>
</template>

<script>
  import {
    getAction,
    deleteAction
  } from '@/api/manage'
  import {
    mixinDevice
  } from '@/utils/mixin'
  import {
    isNull,
    isUndefined
  } from '@/utils/validate'
  import {
    divideMoneyBy100Filter
  } from '@/filters/moneyFilter.js'
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin'
  import MeterPriceinfoModal from '@/views/meterManagement/modules/MeterPriceinfoModal.vue'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'MeterPriceinfoList',
    filters: {
      divideMoneyBy100Filter
    },
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      MeterPriceinfoModal,
      JInput
    },
    data() {
      return {
        description: 'meter_priceinfo管理页面',
        url: {
          list: "/jeecg-charge/meter/meterPriceinfo/list",
          delete: "/jeecg-charge/meter/meterPriceinfo/delete",
          deleteBatch: "/jeecg-charge/meter/meterPriceinfo/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterPriceinfo/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterPriceinfo/importExcel",
          userList: "/jeecg-charge/meter/meterUserinfo/list",
          PriceItem: "/jeecg-charge/meter/meterPriceItem/list",
        },
        dictOptions: {},
        dataSource1: [],
      }
    },
    created() {},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      importExcelUrl: function() {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [{
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: (t, r, index) => {
              return parseInt(index) + 1;
            }
          },
          // {
          //   title: '价格编号',
          //   align: "center",
          //   dataIndex: 'wtCode'
          // },
          {
            title: this.$t('价格名称'),
            align: "center",
            dataIndex: 'wtName'
          }, {
            title: this.$t('水价总计(元)'),
            align: "center",
            dataIndex: 'wtTotalPrice',
            customRender: (text) => {
              return isNull(text) ? "" : text / 100
            }
          }, {
            title: this.$t('基本水价(元)'),
            align: "center",
            dataIndex: 'wtBasicPrice',
            customRender: (text, record, index) => {
              if (isNull(record.wtTotalPrice)) {
                return ''
              }
              let wtTotalChargePrice = 0
              if (!isNull(record.wtTotalChargePrice)) {
                wtTotalChargePrice = record.wtTotalChargePrice
              }
              let te = divideMoneyBy100Filter
              return te(record.wtTotalPrice - wtTotalChargePrice)
            }
          }, {
            title: this.$t('计费类型'),
            align: "center",
            dataIndex: 'wtFeeType_dictText',
            customRender: (t) => (t ? this.$t(t) : ''),
          }, {
            title: this.$t('禁用状态'),
            align: "center",
            dataIndex: 'statusDisable_dictText',
            customRender: (t) => (t ? this.$t(t) : ''),
          },
          {
            title: this.$t('阶梯数量'),
            align: "center",
            dataIndex: "wtStepNum"
          }, {
            title: this.$t('创建时间'),
            align: "center",
            dataIndex: 'createTime'
          }, {
            title: this.$t('创建人'),
            align: "center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: {
              customRender: 'action'
            }
          }
        ]
      },
      columns1() {
        return [
        //   {
        //   title: '项目代码',
        //   dataIndex: 'priceId',
        //   align: "center",
        // },
        {
          title: this.$t('项目名称'),
          dataIndex: 'priceName',
          align: "center",
        }, {
          title: this.$t('基本单价'),
          dataIndex: 'priceName',
          align: "center",
        }, {
          title: this.$t('收取方式'),
          dataIndex: 'priceWay',
          align: "center",
          customRender: (t, r, index) => {
            let data = {
              "1": this.$t("按量")
            }
            if (isUndefined(typeof data[t])) {
              return this.$t("其他")
            }
            return data[t]
          }
        },{
          title: this.$t('计算公式'),
          dataIndex: 'priceItemFormula',
          align: "center",
        }, {
          title: this.$t('单价（元）'),
          dataIndex: 'price',
          align: "center",
          scopedSlots: {
            customRender: 'price'
          }
        }, {
          title: this.$t('水费类型'),
          dataIndex: 'priceType',
          align: "center",
        }, {
          title: this.$t('是否收取违约金'),
          dataIndex: 'hasPenalty',
          align: "center",
          customRender: (t, r, index) => {
            let data = {
              "0": this.$t("否"),
              "1": this.$t("是")
            }
            if (isUndefined(typeof data[t])) {
              return this.$t("其他")
            }
            return data[t]
          }
        }, ]
      },
    },
    methods: {
      initDictConfig() {},
      handleAdd: function() {
        this.$refs.modalForm.add();
        this.$refs.modalForm.title = this.$t('新增');
        this.$refs.modalForm.disableSubmit = false;
        this.$refs.modalForm.isUsed = false;
      },
      handleDetail: function(record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = this.$t('详情');
        this.$refs.modalForm.disableSubmit = true;
        this.$refs.modalForm.isUsed = false;
      },
      handleEdit: function(record) {
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.userPriceId = record.id
        getAction(this.url.userList, params).then((res) => {
          if (res.success && res.result.records.length > 0) {
            this.$refs.modalForm.isUsed = true;
          } else {
            this.$refs.modalForm.isUsed = false;
          }
          this.$refs.modalForm.disableSubmit = false;
          this.$refs.modalForm.edit(record);
          this.$refs.modalForm.title = this.$t('编辑');
        })


      },
      // 上面选择
      onSelectChange(selectedRowKeys, selectionRows) {
        let that = this;
        this.selectedRowKeys = selectedRowKeys;
        this.dataSource1 = [];
        if (this.selectedRowKeys.length == 0) {
          this.dataSource1 = []
          return;
        }
        let allData = [];
        getAction(this.url.PriceItem).then(res => {
          if (res.success) {
            allData = res.result.records;
            const selectItemRows = selectionRows[0].wtPriceItemList.split(',')
            that.dataSource1 = allData.filter((v) => selectItemRows.some((val) => val == v.id))

            // let clickObject = this.dataSource.find(d=>d.id == selectedRowKeys[0]);
            // clickObject.wtPriceItemList && clickObject.wtPriceItemList.split(',').map(id=>{
            //   let object = allData.find(all=>all.id = id);
            //   that.dataSource1.push(object);
            // });
          }
        });

      },
      customRow(record, index) {
        return {
          on: {
            click: (e) => {
              this.selectedRowKeys = [e.currentTarget.dataset.rowKey];
              let that = this;
              this.dataSource1 = [];
              let allData = [];
              getAction(this.url.PriceItem).then(res => {
                if (res.success) {
                  allData = res.result.records;
                  let clickObject = this.dataSource.find(d => d.id == that.selectedRowKeys[0]);
                  const selectItemRows = clickObject.wtPriceItemList.split(',')
                  that.dataSource1 = allData.filter((v) => selectItemRows.some((val) => val == v.id))
                  
                  // let clickObject = this.dataSource.find(d => d.id == that.selectedRowKeys[0]);
                  // clickObject.wtPriceItemList && clickObject.wtPriceItemList.split(',').map(id => {
                  //   let object = allData.find(all => all.id = id);
                  //   that.dataSource1.push(object);
                  // });
                }
              });

            }
          }
        }
      },
    }
  }
</script>
<style scoped>
  .top-table{
    padding-bottom: 10px;
    border-bottom: 2px dashed #666;
  }
</style>